import { Skeleton, Typography } from '@client/toolkit';
import classNames from 'classnames';
import { FaArrowTrendDown, FaArrowTrendUp } from 'react-icons/fa6';
import { MetricCard } from '../../components/metric-card';

export function ReportingContractLengthCard({
  title,
  value,
  showDirection,
  loading,
  unit,
}: {
  title: string;
  value: number;
  unit: string;
  showDirection?: boolean;
  loading?: boolean;
}) {
  return (
    <MetricCard title={title}>
      <span
        className={classNames(
          'flex items-baseline',
          showDirection ? 'gap-1' : 'gap-2',
          showDirection && value !== 0 ? (value > 0 ? 'text-positive' : 'text-negative') : '',
        )}
      >
        {loading ? (
          <Skeleton variant="text" className="w-[120px]" />
        ) : (
          <>
            {showDirection && value !== 0 ? (
              value > 0 ? (
                <FaArrowTrendUp size={24} />
              ) : (
                <FaArrowTrendDown size={24} />
              )
            ) : null}
            <Typography variantFontSize="h2">{value}</Typography>
            <Typography
              variantFontSize={showDirection ? 'h2' : 'sub'}
              className={classNames(showDirection ? '' : 'text-white/60')}
            >
              {unit}
            </Typography>
          </>
        )}
      </span>
    </MetricCard>
  );
}
